/* eslint-disable import/prefer-default-export */
/* eslint-disable no-console */
import { isEmpty, map } from 'lodash'
import uuidv4 from 'uuid/v4'
import type {
  APIResponse,
  MakeRequestOptions,
  RequestOptions
} from './make.request'
import {
  GetFeatureFlagReq,
  GetFeatureFlagResp,
  TenantMgr
} from './services/tenantMgr.service'

export interface FeatureFlagResp {
  response: GetFeatureFlagAsyncResp
  error?: string
  pending: boolean
}

export type RegistredFeatureflag =
  | 'CAM_PERM_20201022_ENABLE_PENDO'
  | 'CAM_TEMP_20201120_SCOPED_ROLE'
  | 'CAM_TEMP_20210127_USE_REPORT_SERVICE'
  | 'CAM_TEMP_20220209_SOURCES_IMPROVEMENTS'
  | 'CAM_TEMP_20210817_ALERTS_IMPROVEMENTS'
  | 'CAM_TEMP_20220216_IDENTITY_TAB_OPTIMIZATIONS'
  | 'CAM_TEMP_20220623_IDN_LOGIN_PATH'
  | 'CAM_TEMP_20220920_FIX_NOT_ALLOW_DISABLING_AWS_TOP_ORG_ACCOUNT'
  | 'CAM_PERM_20230314_UI_HIDE_CHANGES'
  | 'CAM_TEMP_20220623_IDN_LOGIN_PATH'
  | 'CAM_PERM_20220804_HIDE_DASHBOARD'
  | 'CAM_PERM_20220804_HIDE_RESOURCES_ACCESS'
  | 'CAM_PERM_20220804_HIDE_ALL_SOURCE'
  | 'CAM_PERM_20220804_HIDE_AUTOCOMPLETE'
  | 'CAM_PERM_20220804_HIDE_ALERTS_GUARDRAILS'
  | 'CAM_TEMP_20220920_SCOPES_HYERARCHY_PART_SELECTION_FIX'
  | 'CAM_TEMP_20221007_INCREASE_PROGRESS_REQUEST_INTERVAL'
  | 'CAM_TEMP_20221114_INPUT_TOOLTIP_FIX'
  | 'CAM_TEMP_20230620_ENABLE_SUPPORT_SNS_TRAIL_ARN'
  | 'TEST_FLAG'

export interface GetFeatureFlagAsyncResp
  extends APIResponse<GetFeatureFlagResp> {
  featureflag?: RegistredFeatureflag
  value?: boolean
}

export const dashboardMenuItem = 'Dashboard'

export function fetchFeatureFlag(
  flag: RegistredFeatureflag,
  options?: RequestOptions,
  makeRequestOptions?: Partial<MakeRequestOptions<GetFeatureFlagReq>>
): Promise<APIResponse<GetFeatureFlagResp>> {
  const params: GetFeatureFlagReq = {
    req_hdr: { tid: uuidv4() }
  }
  return TenantMgr.GetFeatureFlag({
    params,
    queryVars: {
      featureflag: flag
    },
    options,
    makeRequestOptions
  })
}

export function getFeatureFlags(
  flags: RegistredFeatureflag[] = [],
  options?: RequestOptions,
  makeRequestOptions?: Partial<MakeRequestOptions<GetFeatureFlagReq>>
) {
  const out: { [key in RegistredFeatureflag]?: FeatureFlagResp } = {}
  const requests = map(flags, flag =>
    fetchFeatureFlag(flag, options, makeRequestOptions)
  )
  return Promise.all(requests).then(responses => {
    if (
      responses.find(
        response =>
          response.featureflag === 'CAM_PERM_20220804_HIDE_ALL_SOURCE' &&
          response.value
      )
    ) {
      const hostname = window.location.hostname
      const protocol = window.location.protocol
      const organization = hostname.split('.')[0]
      let replaceURL = `${protocol}//${organization}.sailpoint.com`

      if (hostname.includes('.cam.cloud.sailpoint.com')) {
        const org = hostname.split('.cam.cloud.sailpoint.com')[0]
        replaceURL = `${protocol}//${org}.identitysoon.com/ui/d/dashboard`
      } else if (hostname.includes('.cam.sailpoint.com')) {
        const org = hostname.split('.cam.sailpoint.com')[0]
        replaceURL = `${protocol}//${org}.identitynow.com/ui/d/dashboard`
      } else if (hostname.includes('.cam-demo.sailpoint.com')) {
        const org = hostname.split('.cam-demo.sailpoint.com')[0]
        replaceURL = `${protocol}//${org}.identitynow-demo.com/ui/d/dashboard`
      }

      window.location.href = replaceURL
    }
    for (const response of responses) {
      const { error, featureflag } = response
      if (!isEmpty(error)) {
        console.error(`Unable to retrieve feature flag for ${featureflag}!`)
      } else {
        out[featureflag] = { response, error, pending: false }
      }
    }
    return out
  })
}

export async function getFeatureFlagAsync(
  flag: RegistredFeatureflag,
  options?: RequestOptions,
  makeRequestOptions?: Partial<MakeRequestOptions<GetFeatureFlagReq>>
): Promise<GetFeatureFlagAsyncResp> {
  const response = await fetchFeatureFlag(flag, options, makeRequestOptions)
  const { error, featureflag, value } = response
  if (!isEmpty(error)) {
    console.error(`Unable to retrieve feature flag for ${featureflag}!`)
  } else if (featureflag === flag) {
    return { featureflag, value }
  }
  return {}
}
